<route lang="json">
{
  "name": "website-public-show",
  "meta": {
    "namespace": "website"
  }
}
</route>
<script setup lang="ts">
import ProsaHtml from "@/components/ProsaHtml.vue";
import { type User } from "@/services/orval/internalApiV1";

const namespace = "website";
const routes = createRouteNamesFromNamespace(namespace);

const route = useRoute();
const pageId = computed(() => route.params.id as string);

const { getQuery } = useWebsitePageQueries();
const { data: websitePage, ...asyncStatus } = getQuery(pageId);

const userStore = useUserStore();
const isAuthor = computed(
  () => websitePage.value?.userId === (userStore.user as User)?.toolsUserId
);

const appsStore = useAppsStore();
const app = appsStore.findAppByNamespace(namespace);
</script>

<template>
  <WithVisitor>
    <AsyncLoader :async-status="asyncStatus">
      <template v-if="websitePage && app" #resolved>
        <TheLayout
          :enable-bg-pattern="false"
          :enable-tabs="isAuthor"
          mini-footer
        >
          <NavbarToolPreview
            v-if="isAuthor"
            :item="websitePage"
            :route-name-show="routes.show"
          />
          <NavbarToolPublic
            v-else
            :app="app"
            :item="websitePage"
            :route-name-show="routes.show"
          />

          <ProsaHtml :text="websitePage.body || ''" />
        </TheLayout>
      </template>
    </AsyncLoader>
  </WithVisitor>
</template>
